export const DEX_TRANCHE_DETAILS_WIDGET_TYPE_ID = 'DexTrancheDetailsWidget';
